import { Card, Section } from "@edp-models/benefits.model";
import { IUserAvailableParish, UserParticipation } from "@edp-models/edp-campaigns.model";
import { IUserEfficiency } from "@edp-models/energy-efficiency.model";

export interface IEdpeState {
    dashboardCards: Card[];
    dashboardGeneratedCodeCards: Card[];
    showAlert: boolean;
    userEfficiency: IUserEfficiency;
    dashboardSections: Section[];
    loadedDashboard: boolean;
    userAvailableParishList: IUserAvailableParish[];
    userParticipation: UserParticipation;
    mgmCode: any;
    quizzs: any;
}

export const initialEdpeState: IEdpeState = {
    dashboardCards: null,
    dashboardGeneratedCodeCards: [],
    showAlert: true,
    userEfficiency: null,
    dashboardSections: [],
    loadedDashboard: false,
    userAvailableParishList: [],
    userParticipation: null,
    mgmCode: null,
    quizzs: null
};
